import { EventProps } from 'react-big-calendar';
import EventComponent from './EventComponent';
import WorkboardTaskEventComponent from './WorkboardTaskEventComponent';
import { isWorkboardTaskCalendarEvent } from '../ModelsCalendar.types';

const CalendarEventComponent = (props: EventProps) => {
  if (isWorkboardTaskCalendarEvent(props.event)) {
    return <WorkboardTaskEventComponent {...props} />;
  }

  return <EventComponent {...props} />;
};

export default CalendarEventComponent;
